// Picks the next action to process: the head of whichever planet's queue
// currently has the smallest planet-local time. Deactivated actions are
// still returned (so the caller can echo them into the timeline) but are
// never preferred over an active one at an earlier time than the current
// best candidate — matches legacy SmartActionChooser exactly.
export const SmartActionChooser = (state, buildOrder) => {
  let index;
  let action;
  let time = 0;

  for (const planetId of Object.keys(state.planets)) {
    if (!buildOrder[planetId] || buildOrder[planetId].length === 0) continue;

    const currIndex = state.planets[planetId].index;
    const currAction = buildOrder[planetId][0];

    if (currAction.deactivated === true) {
      if (index === undefined || action === undefined) {
        index = currIndex;
        action = currAction;
        time = state.planets[planetId].time;
      }
      if (state.planets[planetId].time < time) {
        index = currIndex;
        action = currAction;
        time = state.planets[planetId].time;
      }
      continue;
    }

    if (index === undefined || action === undefined) {
      index = currIndex;
      action = currAction;
      time = state.planets[planetId].time;
    }
    if (state.planets[planetId].time < time) {
      index = currIndex;
      action = currAction;
      time = state.planets[planetId].time;
    }
  }

  if (index !== undefined && action !== undefined) {
    state.planets[action.payload.planetId].index++;
    buildOrder[action.payload.planetId].shift();
  }

  return [index, action];
};

// Inserts an incoming transport into the target planet's fleetActions,
// keeping the list sorted by remaining duration.
export const addFleetAction = (state, sourceTime, target, action) => {
  if (state.planets[target] === undefined) return;
  const settings = action.payload.settings;
  const targetTime = state.planets[target].time;
  // Planets tick independently until GameReducer's final sync step, so the
  // target's own clock can already be further ahead than
  // sourceTime + flight_time by the time this fleet is dispatched (e.g. a
  // long-running main planet vs. a colony whose build order took a while
  // to reach this transport). That's not an impossible flight -- clamping
  // to 0 (rather than dropping the action) treats it as arriving as soon
  // as the target planet's own queue gets around to it, so it still gets
  // completed/awaited instead of silently vanishing from the plan.
  const duration = Math.max(sourceTime - targetTime + settings.flight_time, 0);
  settings.flight_time = duration;
  let i = 0;
  while (state.planets[target].fleetActions.length > i && state.planets[target].fleetActions[i].duration < duration) {
    i++;
  }
  state.planets[target].fleetActions.splice(i, 0, action);
};
